const PREFIX:string = "https://kia-icons.s3.ap-south-1.amazonaws.com/";
export const Icons = {
    back: "https://kia-icons.s3.ap-south-1.amazonaws.com/back.png",
    auto_gen: PREFIX + "auto.png",
    global: PREFIX + "global.png",
    private: PREFIX + "private.png",
    time: PREFIX + "time.png",
    search: PREFIX + "loupe.png",
    delete: PREFIX + "bin.png",
    qa: {
        processing: PREFIX + "qa-processing.png",
        success: PREFIX + "qa-success.png",
        error: PREFIX + "qa-error.png",
    },
    summary: {
        processing: PREFIX + "summary-processing.png",
        success: PREFIX + "summary-success.png",
        error: PREFIX + "summary-error.png",
    },
    bookmarks: {
        yes: PREFIX + "bookmarkyes.png",
        no: PREFIX + "bookmark-no.png"
    },
    checkbox: {
        checked: PREFIX + "check.png",
        unchecked: PREFIX + "uncheck.png"
    }    
}